module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Jim's Blog","short_name":"JC Blog","start_url":"/","background_color":"#dedede","theme_color":"#dedede","display":"minimal-ui","icon":"src/images/jc-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"77ea848ebae5a84dded2a05ced6dcf38"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
